import axios from 'axios';

export const SettingsApi = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/api/Settings/Settings/`,
});
